// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zjdS","toggle":"styles_toggle__1SrI-","preview":"styles_preview__3tEc2"};